import { data } from "jquery";
import * as types from "./types";

const mutations = {
    [types.LOADING_ATTENDANCE](state, value) {
        state.loading = value;
    },
    [types.GET_ATTENDANCE_LIST](state, attendance) {
        state.attendance = attendance;
    },
    [types.ADD_ATTENDANCE](state, attendance) {        
        state.attendance.unshift(attendance);
    },
    [types.UPDATE_ATTENDANCE](state, attendance) {        
        const attendanceIndex = state.attendance.findIndex((x) => x.id === attendance.id);
        state.attendance[attendanceIndex] = attendance;        
    },
    [types.IMPORT_ATTENDANCE](state, attendance) {
            state.attendance = attendance;
        },
};

export default mutations;